import { BRAND, CONTACT_EMAIL, voices } from "@/mocks/melon";

const principles = [
  { icon: "ri-link", title: "信源优先", text: "能标注出处的都标注出处，拿不准的一律提示“待证实”，把判断权交还给你。" },
  { icon: "ri-shield-check-line", title: "不越界", text: "不转载隐私、不网暴当事人，只围绕已公开、有公共讨论价值的话题做整理。" },
  { icon: "ri-text", title: "克制表达", text: "少一点带节奏的标题党，多一点冷静的梳理，让你看完能自己得出结论。" },
  { icon: "ri-refresh-line", title: "跟上节奏", text: "响应要快但不要抢跑，热点信息经过快速核验后再上线，宁可慢半拍也不错传。" },
];

function About() {
  return (
    <section id="about" className="scroll-mt-24 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-14">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-primary-600">About Us</p>
            <h2 className="mt-2 font-heading text-2xl font-extrabold tracking-tight text-foreground-950 md:text-4xl">
              关于{BRAND}
            </h2>
            <p className="mt-5 text-sm leading-relaxed text-foreground-600 md:text-[15px]">
              {BRAND}是一个专注全网热点与娱乐资讯的轻量内容站点，主打“实时跟进、信源清晰、吃瓜有度”。我们把散落在各平台的热搜瓜点集中到一个地方，帮你用最短时间掌握正在发生的事，也陪你把每件事看明白。
            </p>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-[15px]">
              我们不追流量、不制造焦虑，只做一件事：让“吃瓜”这件小事，更快一点、也更体面一点。无论你是追更党、理性派，还是偶尔路过的吃瓜群众，都能在这里找到适合自己的打开方式。
            </p>

            <h3 className="mt-8 font-heading text-lg font-bold text-foreground-950">我们的内容原则</h3>
            <ul className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {principles.map((p) => (
                <li key={p.title} className="flex gap-3 rounded-lg bg-background-100 p-4">
                  <span className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-accent-100 text-lg text-accent-700">
                    <i className={p.icon} />
                  </span>
                  <div>
                    <h4 className="text-sm font-bold text-foreground-950">{p.title}</h4>
                    <p className="mt-1 text-xs leading-relaxed text-foreground-600">{p.text}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="rounded-2xl border border-background-200 bg-background-100 p-6 md:p-7">
              <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                <i className="ri-double-quotes-l text-primary-500" />
                大家怎么评价{BRAND}
              </h3>
              <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2">
                {voices.map((v) => (
                  <figure key={v.name} className="flex flex-col rounded-xl border border-background-200 bg-background-50 p-5">
                    <div className="flex items-center justify-between">
                      <span className="inline-flex items-center gap-1.5 text-xs text-foreground-500">
                        <i className="ri-star-fill text-accent-500" />
                        真实用户口碑
                      </span>
                      <span className="rounded bg-accent-100 px-2 py-0.5 text-[11px] font-semibold text-accent-700">{v.tag}</span>
                    </div>
                    <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">“{v.text}”</blockquote>
                    <figcaption className="mt-4 flex items-center gap-3 border-t border-background-200 pt-3">
                      <span className="flex h-9 w-9 items-center justify-center rounded-full bg-gradient-to-br from-secondary-500 to-secondary-700 text-sm font-bold text-background-50">
                        {v.name.charAt(0)}
                      </span>
                      <div className="leading-tight">
                        <div className="text-sm font-bold text-foreground-900">{v.name}</div>
                        <div className="text-xs text-foreground-500">{v.role}</div>
                      </div>
                    </figcaption>
                  </figure>
                ))}
              </div>
            </div>

            <div className="mt-5 flex flex-col gap-4 rounded-2xl bg-gradient-to-br from-primary-500 to-primary-700 p-6 text-background-50 sm:flex-row sm:items-center sm:justify-between md:p-7">
              <div>
                <h3 className="font-heading text-lg font-bold">有线索想告诉我们？</h3>
                <p className="mt-1 text-sm text-background-50/85">欢迎投稿爆料或提出建议，我们会在核实后跟进。</p>
                <a
                  href={`mailto:${CONTACT_EMAIL}`}
                  className="mt-2 inline-flex items-center gap-1.5 text-sm font-semibold text-accent-200 hover:text-accent-100"
                >
                  <i className="ri-mail-line" />
                  {CONTACT_EMAIL}
                </a>
              </div>
              <a
                href="#latest"
                className="inline-flex h-11 shrink-0 items-center justify-center gap-1.5 rounded-md bg-background-50 px-5 text-sm font-semibold text-primary-700 transition-colors hover:bg-background-100 whitespace-nowrap"
              >
                先去吃两口瓜 <i className="ri-arrow-right-line" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;